<template>
  <div class="row">
    <h4>Influencers hash</h4>
    <table class="table table-striped">
      <thead>
        <tr>
          <td>#</td>
          <td>Name</td>
          <td>Firstname</td>
          <td>Lastname</td>
          <td>Nickname</td>
          <td>Category</td>
          <td>Site</td>
          <td>Status</td>
          <td></td>
        </tr>
      </thead>
      <tbody>
        <tr v-for="influencer in influencers">
          <td>{{influencer.id}}</td>
          <td>{{influencer.name}}</td>
          <td>{{influencer.firstname}}</td>
          <td>{{influencer.lastname}}</td>
          <td>{{influencer.nickname}}</td>
          <td>{{influencer.category_id}}</td>
          <td>{{influencer.site}}</td>
          <td>{{influencer.status}}</td>
          <td>
            <span @click="copyInfluencer(influencer.id)">Copy</span>
          </td>
        </tr>
      </tbody>
    </table>

    <div class="col-sm-12 text-center">
      <button v-on:click="loadMore()" class="btn btn-default">Load more</button>
    </div>
  </div>

</template>

<script>
  export default {
    name: "influencers-hash",
    data() {
      return {
        limit: 10,
        offset: 0,
        filter: {

        },
        influencers: [],
        apiHost: this.$appSettings.getSetting('host')
      }
    },
    methods: {
      getInfluencers(limit, offset, init) {
        this.$http.get(this.apiHost + 'hash/influencers/get/list', {
          params: {
            token: this.$auth.getToken(),
            limit: limit,
            offset: offset,
            filter: this.filter
          }
        }).then(response => {
          if (init) {
            this.influencers = response.body.data.influencers;
          } else {
            for(let influencer in response.body.data.influencers) {
              this.influencers.push(response.body.data.influencers[influencer]);
            }
          }
        })
      },
      loadMore() {
        this.getInfluencers(this.limit, this.influencers.length, false);
      },
      copyInfluencer(influencerId) {
        this.$http.post(this.apiHost + 'hash/influencers/copy', {
          influencer_id: influencerId
        }, {
          params: {
            token: this.$auth.getToken()
          }
        }).then(response => {
          this.getInfluencers(this.influencers.length, 0, true);
        });
      }
    },
    created: function() {
      this.getInfluencers(this.limit, this.offset, true);
    }
  }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/influencer/InfluencersHash.vue